var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container-no-data-to-show"},[(_vm.title)?_c('p',{staticClass:"title-no-data"},[_vm._v(_vm._s(_vm.$t(_vm.title)))]):_vm._e(),(_vm.subtitle)?_c('p',{staticClass:"subtitle-no-data"},[_vm._v(_vm._s(_vm.$t(_vm.subtitle)))]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }